import CoachScreen from "../features/coach/CoachScreen";

export default function AICoach() {
  return <CoachScreen />;
}
